import { forwardRef, Component, Input, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxInputStarRatingComponent_button_1_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_span_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 11);
    ɵngcc0.ɵɵelement(3, "polygon", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(3);
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(3);
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_1_Template, 4, 1, "span", 8);
    ɵngcc0.ɵɵtemplate(2, NgxInputStarRatingComponent_button_1_ng_container_2_span_2_Template, 2, 1, "span", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r3.icon === ctx_r6.starIcons.half);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r3.icon !== ctx_r6.starIcons.full && btn_r3.icon !== ctx_r6.starIcons.half);
} }
function NgxInputStarRatingComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function NgxInputStarRatingComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const i_r4 = ctx.index; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.rate(i_r4); })("mouseenter", function NgxInputStarRatingComponent_button_1_Template_button_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const i_r4 = ctx.index; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.mouseEnter(i_r4); });
    ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_span_1_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵtemplate(2, NgxInputStarRatingComponent_button_1_ng_container_2_Template, 3, 2, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵattribute("aria-label", "rate " + (i_r4 + 1) + " of " + ctx_r0.buttons.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r3.active || btn_r3.icon === ctx_r0.starIcons.full);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r3.active);
} }
function NgxInputStarRatingComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 14);
    ɵngcc0.ɵɵelement(1, "polygon", 12);
    ɵngcc0.ɵɵelementEnd();
} }
const starIcons = {
    outline: 'outline',
    full: 'full',
    half: 'half'
};
class NgxInputStarRatingComponent {
    constructor() {
        this._value = 0;
        this.count = 5;
        this.disabled = false;
        this.starIcons = starIcons;
        this.buttons = [];
        // tslint:disable-next-line:no-empty
        this.onChange = (_value) => { };
        // tslint:disable-next-line:no-empty
        this.onTouched = () => { };
    }
    /**
     * @return {?}
     */
    get value() {
        return this._value;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.valueUpdate(this._value);
        this.onTouched();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value !== this.value) {
            this.value = value;
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        for (let /** @type {?} */ i = 0; i < this.count; i++) {
            this.buttons.push({ active: false, icon: starIcons.outline });
        }
        this.valueUpdate(this.value);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["value"] && changes["value"].currentValue) {
            this.valueUpdate(changes["value"].currentValue);
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    rate(index) {
        this.buttons.forEach((btn, i) => {
            if (i <= index) {
                btn.icon = starIcons.full;
            }
            else {
                btn.icon = starIcons.outline;
            }
        });
        const /** @type {?} */ total = this.buttons.reduce((prev, next) => {
            if (next.icon === starIcons.full) {
                return prev + 1;
            }
            else {
                return prev;
            }
        }, 0);
        this.value = total;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    mouseEnter(index) {
        this.buttons.forEach((btn, i) => {
            if (i <= index) {
                btn.active = true;
            }
            else {
                btn.active = false;
            }
        });
    }
    /**
     * @return {?}
     */
    mouseLeave() {
        this.buttons.forEach(i => (i.active = false));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    valueUpdate(value) {
        this.buttons.forEach((btn, i) => {
            const /** @type {?} */ starValue = i + 1;
            if (value >= starValue) {
                btn.icon = starIcons.full;
            }
            if (value >= starValue - 0.5 && value < starValue) {
                btn.icon = starIcons.half;
            }
        });
    }
}
NgxInputStarRatingComponent.ɵfac = function NgxInputStarRatingComponent_Factory(t) { return new (t || NgxInputStarRatingComponent)(); };
NgxInputStarRatingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxInputStarRatingComponent, selectors: [["ngx-input-star-rating"]], inputs: { _value: ["value", "_value"], count: "count", disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NgxInputStarRatingComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 1, consts: [[1, "input-rating", 3, "mouseleave"], ["type", "button", "class", "input-rating__btn", 3, "disabled", "click", "mouseenter", 4, "ngFor", "ngForOf"], ["star", ""], ["type", "button", 1, "input-rating__btn", 3, "disabled", "click", "mouseenter"], ["class", "full", 4, "ngIf"], [4, "ngIf"], [1, "full"], [4, "ngTemplateOutlet"], ["class", "half", 4, "ngIf"], ["class", "empty", 4, "ngIf"], [1, "half"], ["height", "25", "width", "10", 1, "star-half"], ["points", "9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78", 2, "fill-rule", "nonzero"], [1, "empty"], ["height", "25", "width", "23", 1, "star"]], template: function NgxInputStarRatingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mouseleave", function NgxInputStarRatingComponent_Template_div_mouseleave_0_listener() { return ctx.mouseLeave(); });
        ɵngcc0.ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_Template, 3, 4, "button", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, NgxInputStarRatingComponent_ng_template_2_Template, 2, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: ["*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]::before, *[_ngcontent-%COMP%]::after{\n  -webkit-box-sizing:border-box;\n          box-sizing:border-box; }\n[_nghost-%COMP%]{\n  display:inline-block; }\n.star[_ngcontent-%COMP%]{\n  fill:#ccc; }\n.full[_ngcontent-%COMP%]   .star[_ngcontent-%COMP%]{\n  fill:gold; }\n.half[_ngcontent-%COMP%]   .star-half[_ngcontent-%COMP%]{\n  fill:gold; }\nbutton[_ngcontent-%COMP%]{\n  background-color:transparent;\n  border:0;\n  cursor:pointer;\n  position:relative;\n  width:30px;\n  height:25px; }\n  button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{\n    position:absolute;\n    top:0;\n    left:5px; }"] });
/** @nocollapse */
NgxInputStarRatingComponent.ctorParameters = () => [];
NgxInputStarRatingComponent.propDecorators = {
    "_value": [{ type: Input, args: ['value',] },],
    "count": [{ type: Input },],
    "disabled": [{ type: Input },],
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxInputStarRatingComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-input-star-rating',
                template: `<div class="input-rating" (mouseleave)="mouseLeave()">
  <button type="button" [disabled]="disabled" *ngFor="let btn of buttons; let i = index" class="input-rating__btn" (click)="rate(i)" [attr.aria-label]="'rate ' + (i + 1) + ' of ' + buttons.length"
    (mouseenter)="mouseEnter(i)">
    <span *ngIf="btn.active || btn.icon === starIcons.full" class="full">
      <ng-container *ngTemplateOutlet="star"></ng-container>
    </span>
    <ng-container *ngIf="!btn.active">
      <span *ngIf="btn.icon === starIcons.half" class="half">
        <ng-container *ngTemplateOutlet="star"></ng-container>
        <svg height="25" width="10" class="star-half">
          <polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" style="fill-rule:nonzero;"/>
        </svg>
      </span>
      <span *ngIf="btn.icon !== starIcons.full && btn.icon !== starIcons.half" class="empty">
        <ng-container *ngTemplateOutlet="star"></ng-container>
      </span>
    </ng-container>
  </button>
</div>
<ng-template #star>
  <svg height="25" width="23" class="star">
    <polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" style="fill-rule:nonzero;"/>
  </svg>
</ng-template>`,
                styles: [`*, *::before, *::after{
  -webkit-box-sizing:border-box;
          box-sizing:border-box; }
:host{
  display:inline-block; }
.star{
  fill:#ccc; }
.full .star{
  fill:gold; }
.half .star-half{
  fill:gold; }
button{
  background-color:transparent;
  border:0;
  cursor:pointer;
  position:relative;
  width:30px;
  height:25px; }
  button svg{
    position:absolute;
    top:0;
    left:5px; }
`],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NgxInputStarRatingComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { _value: [{
            type: Input,
            args: ['value']
        }], count: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxInputStarRatingModule {
}
NgxInputStarRatingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxInputStarRatingModule });
NgxInputStarRatingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxInputStarRatingModule_Factory(t) { return new (t || NgxInputStarRatingModule)(); }, imports: [[
            CommonModule
        ]] });
/** @nocollapse */
NgxInputStarRatingModule.ctorParameters = () => [];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxInputStarRatingModule, { declarations: function () { return [NgxInputStarRatingComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxInputStarRatingComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxInputStarRatingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxInputStarRatingComponent
                ],
                exports: [
                    NgxInputStarRatingComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { NgxInputStarRatingModule, NgxInputStarRatingComponent as ɵa };

//# sourceMappingURL=ngx-input-star-rating.js.map